export default "__VITE_ASSET__DqeTdbTI__"